import { jsx as _jsx } from "react/jsx-runtime";
export function TableHead({ children, style }) {
    return (_jsx("th", { style: style, className: "p-4 text-left text-gray-700 font-medium text-sm text-nowrap", children: children }));
}
